type IProps = {
    source: string,
    className?: string,
    alt: string,
    width?: number | string,
    height?: number | string
}

const ImageComponent = ({ source, alt, className, width = 'auto', height = 'auto', ...otherProps }: IProps) => {

    return (
        <img width={width} height={height} src={source} className={`${className}`} alt={alt} {...otherProps} />
    )
}

export default ImageComponent